import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { Redirect, useLocation } from "react-router-dom";
import { Loader } from "../loader/loader";
import { pendingBookingStore } from "../../stores/pending-booking.store";
import { DetailsVouchers } from "../details/details-vouchers/details-vouchers";
import { buildRouteWithParams } from "../../helpers/build-route-with-params";
import { config } from "../../config";
import { CommercialsDisplay } from "./commercials-display/commercials-display";
import CommercialsService from "../../services/commercials.service";
import {
  AcceptedPositions,
  ContinueButton,
} from "../continue-button/continue-button";
import { SummaryCriteria } from "../summary-criteria/summary-criteria";
import {
  DetailsVoucherCtx,
  CommercialMenuItemCtx,
} from "../../contexts/commercial-context";
import { ErrorMessage } from "../errors/message-error-view";

const CommercialsWrapper = styled.div`
  position: relative;
`;

const CommericalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Router = () => {
  const commercialsService = CommercialsService;
  const hasCommercials = commercialsService.hasCommercials();
  const [error, setError] = useState<any>(useLocation().state);
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const isVoucherEnabled = pendingBookingStore.getIsVoucherEnabled();
  const [redirect] = useState(!hasCommercials && !isVoucherEnabled);
  const [validVoucherCode, setValidVoucherCode] = useState(false);
  const [statisfyMenusMandatory, setStatisfyMenusMandatory] = useState(
    pendingBookingStore.menuSelectionRequested
      ? pendingBookingStore.selectedMenus.length > 0
      : true
  );
  const [disabledBtnReqFromVoucher, setDisabledBtnReqFromVoucher] =
    useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [commercialsService]);

  useEffect(() => {
    setIsDisabled(disabledBtnReqFromVoucher || !statisfyMenusMandatory);
  }, [statisfyMenusMandatory, disabledBtnReqFromVoucher]);

  const setChildLoading = (state: boolean) => {
    setIsLoading(state);
    setError("");
  };

  let buttonText = "button.skip";

  if (
    commercialsService.hasEvents() ||
    pendingBookingStore.menuSelectionRequested ||
    pendingBookingStore.selectedMenus.length > 0 ||
    pendingBookingStore.selectedOffer ||
    validVoucherCode
  ) {
    buttonText = "button.continue";
  }

  const content = (
    <CommericalContentWrapper>
      {error && error["errorDetails"] && (
        <ErrorMessage
          error={error["error"]}
          status={"Error"}
          data-test="error-message"
        />
      )}
      <SummaryCriteria />
      <DetailsVoucherCtx.Provider
        value={{
          updateDisabledBtnFromVoucher: (disabled) =>
            setDisabledBtnReqFromVoucher(disabled),
          updateValidVoucherCode: (loading) => setValidVoucherCode(loading),
        }}
      >
        {isVoucherEnabled && <DetailsVouchers />}
      </DetailsVoucherCtx.Provider>
      <CommercialMenuItemCtx.Provider
        value={{
          updateStatisfyMenusMandatory: (satisfied) =>
            setStatisfyMenusMandatory(satisfied),
        }}
      >
        {hasCommercials && (
          <CommercialsDisplay setChildLoading={setChildLoading} />
        )}
      </CommercialMenuItemCtx.Provider>
      <ContinueButton
        position={AcceptedPositions.center}
        route={buildRouteWithParams(config.routes.confirmation)}
        buttonTextKey={buttonText}
        disabled={isDisabled}
      />
      {redirect && (
        <Redirect to={buildRouteWithParams(config.routes.confirmation)} />
      )}
    </CommericalContentWrapper>
  );

  return (
    <CommercialsWrapper>
      {content}
      {isLoading ? <Loader /> : ""}
    </CommercialsWrapper>
  );
};

export const Commercials = memo(Router);
